import { Check } from "lucide-react";

const STEPS = [
  { key: "borrador", label: "Borrador" },
  { key: "enviada", label: "Enviada" },
  { key: "aceptada", label: "Aceptada c/ P.O." },
  { key: "surtido", label: "Surtido" },
  { key: "enviado", label: "Enviado" },
  { key: "cerrado", label: "Cerrado" },
];

export function StatusBar({ current }) {
  const idx = STEPS.findIndex((s) => s.key === current);
  return (
    <div className="flex flex-wrap gap-1" data-testid="status-bar">
      {STEPS.map((s, i) => {
        const done = i < idx;
        const active = i === idx;
        return (
          <div key={s.key}
            className={`relative flex items-center px-4 py-2 text-xs font-medium clip-chevron ${
              active ? "bg-interactive text-white" : done ? "bg-primary text-white" : "bg-muted text-muted-foreground"
            }`}
            style={{ clipPath: i === 0 ? "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%)" : "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)" }}>
            <span className="flex items-center gap-1.5">{done && <Check className="w-3 h-3" />}{s.label}</span>
          </div>
        );
      })}
    </div>
  );
}
